/*
 * Entities are objects that are represented in the database, are fetched through the API, and
 * represented in the state in a normalized (flat) structure. API middleware handles normalization
 * before *_SUCCESS actions are called.
 */

import { combineReducers } from "redux";

import kits from "./entities/kits";
import kitMembers from "./entities/kitMembers";
import spaces from "./entities/spaces";
import spaceMembers from "./entities/spaceMembers";
import kitVersions from "./entities/kitVersions";
import users from "./entities/users";
import sections from "./entities/sections";
import invitations from "./entities/invitations";
import items from "./entities/items";
import shortIds from "./entities/shortIds";
import kitCollections from "./entities/kitCollections";
import kitCollectionItems from "./entities/kitCollectionItems";
import assets from "./entities/assets";
import fields from "./entities/fields";
import views from "./entities/views";

export default combineReducers({
  spaces,
  kits,
  kitCollections,
  kitCollectionItems,
  kitVersions,
  sections,
  items,
  users,
  spaceMembers,
  kitMembers,
  invitations,
  shortIds,
  assets,
  fields,
  views,
});
